<template>
  <div class="login-box">
    <div class="content-box">
      <div class="img-bg">
        <img
          style="height: 100%; width: 100%"
          src="@/assets/images/notfoundBg.png"
          alt="nofound"
        />
        <img
          class="cuise-img"
          src="@/assets/images/cuiseNot.png"
          alt="nofound"
        />
      </div>
      <div class="back-btn">
        <i class="el-icon-back" ></i>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">HOME</el-breadcrumb-item>
          <el-breadcrumb-item >
            <span style="cursor:default;font-weight: 600;color:#09CA6A;">Login</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div class="bg-box"></div>

    <div class="form-box" >
      <div class="top-box"> 
        <a @click="preTab" class="back">
          <i class="el-icon-back"></i>
        </a>
        <span style="flex: 1;" ></span>
        <a @click="goBack" class="close">
          <i class="el-icon-close"></i>
        </a>
      </div>

      <el-carousel ref="carousel" indicator-position="none" :initial-index="currentTab" :autoplay="false" arrow="never" height="400px" 
          @change="changTab">
        <el-carousel-item key="1" style="width:100%;padding: 0 30px;">
          <div>
            <h2>Sign in with mobile number</h2>
            <p>We will send you a code by SMS</p>
            <div class="input-box">
              <div class="area-box">
                <PhoneBtn v-model="form.code"></PhoneBtn>
              </div>
              <input class="input" v-model="form.phone" placeholder="Your phone number" type="phone" />
            </div>
            <div class="check-box" >
              <el-checkbox size="medium" v-model="agree"></el-checkbox>
              <span @click="agree=!agree">Remember me</span>
              <p>
                By submitting your number, you confirm that you accept our <span class="under-line">Terms & Conditions, </span>
                All Eat App <span class="under-line">Terms & Conditions, </span> and acknowledge our <span class="under-line">Privacy Policy.</span>
              </p>
            </div>
            <div :class="['sign-btn','flex-row-center',{'disable-btn':!canGetCode}]" @click="showCaptcha">{{ sendPhonecode }}</div>
          </div>
        </el-carousel-item>

        <el-carousel-item key="2">
          <h2>Enter4 digit code</h2>
          <p>your code was send to <span class="under-line">{{ form.code }} {{ form.phone }}</span></p>
          <div class="ver-code">
            <input  v-model="form.verCode" type="digital" @focus="inputFocus=true" @blur="inputFocus=false"
              @keyup="form.verCode=form.verCode.substring(0,4)" autofocus>
            <div class="mask-box" >
              <span class="font-box" v-for="(item,ind) in 4" :key="ind">
                {{ form.verCode[ind] }} 
                <span class="ol-line" v-if="ind==form.verCode.length"></span>
               </span>
            </div>
          </div>
          <div style="width: 400px;margin:80px auto 0;" :class="['sign-btn','flex-row-center',{'disable-btn':!cantLogin}]" @click="login">Confirm</div>
        </el-carousel-item>
      </el-carousel>

      
    </div>

    <!-- 验证码滑块模块 -->
    <Verify @success="sendcodeMsg"
      :mode="'pop'"
      :captchaType="'blockPuzzle'"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    ></Verify>

  </div>
</template>

<script>
/* eslint-disable */
import { postGateway } from '@/request';
import PhoneBtn from '@/components/PhoneBtn.vue';
import Verify from '@/components/Verifition/Verify';
export default {
  metaInfo: {
    
  },
  name: "Login",
  components: {
    PhoneBtn,
    Verify,
  },
  data() {
    return {
      form: {
        phone: '13295932921',
        code: '+86',
        verCode: '', // 手机验证码
      },
      inputFocus: false,
      currentTab: 0,
      agree: false,
      canGetCode: true,
      sendPhonecode: 'Get OTP',
      num: 0,
    }
  },
  computed: {
    cantLogin() {
      return this.form.verCode.length === 4
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    changTab(index) {
      this.currentTab = index;
    },
    goBack() {
      this.$router.go(-1)
    },
    preTab() {
      this.$refs.carousel.setActiveItem(0);
    },
    nextTab() {
      this.$refs.carousel.setActiveItem(1);
    },
    // 显示验证滑块
    async showCaptcha() {
      if(!this.num==0) return
      if(!this.form.phone.trim()) {
        this.$message({
            message: 'Please enter phone number',
            type: 'warning'
        })
        return
      }
      if(!this.agree) {
        this.$message({
            message: 'Please agree the political',
            type: 'warning'
        })
        return
      }
      if(!this.canGetCode) return
      this.$refs.verify.show()
    },
    //发送手机验证码
    async sendcodeMsg({captchaVerification}) {
      postGateway({
        url: '/customer/atClient/smsSend',
        data: {
          phone: this.form.code + this.form.phone.trim(),
          captchaType: 'register',
          captchaVerification
        }
      }).then((res) => {
        if(res.code == 200){
          this.$message({
            message: 'Verification sent successfully',
            type: 'success'
          })
          this.nextTab();
        }
      })
      this.num = 60;
      this.timer2 = setInterval( ()=> {
          this.num--;
          this.canGetCode = false;
          this.sendPhonecode = this.num + 'seconds later retry';
          if (this.num == 0) {
              this.sendPhonecode = 'send verification code';
              this.canGetCode = true;
              clearInterval(this.timer2)
          }
      }, 1000)
        
    },
    login() {
      let { code, phone } = this.form;
      postGateway({
        url: '/sys/client/clientLogin',
        method: 'POST',
        data: {
          phone: code + phone,
          code: this.form.verCode,
          type: 'web'
        }
      }).then(res=>{
        if(res.data.token) {
          let { token, refreshToken, clientId } = res.data;
          localStorage.setItem('token',token)
          localStorage.setItem('refreshToken',refreshToken)
          localStorage.setItem('clientId', clientId)
          this.$router.replace({
            path: '/index'
          })
        }
        console.log(res,'登录回调')
      })
    }
  }
};
</script>

<style lang="scss" scoped>
$mainColor: #aa0bc0;
$greenColor: #26d07c;
$yellowColor: #ffa132;
.login-box {
  min-height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  position: relative;

  .bg-box {
    flex: 1;
    background-image: url("../assets/images/login_bg.png");
    background-size: cover;
    background-position: center;
  }
  .back-btn {
    position: relative;
    background: #0A191E;;
    height: 36px;
    border-radius: 18px;
    padding: 0 20px;
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin: 30px 6% 0;
    .el-icon-back {
        color: #C2F93A;
        font-size: 22px;
        margin-right: 10px;
    }
    :deep(.el-breadcrumb__inner) {
        color: #fff;
    }
    :deep(.el-breadcrumb__separator) {
        color: #fff;
    }
  }

  .content-box {
    position: relative;
    width: 100%;
    height: 420px;
    .img-bg {
      position: absolute;
      z-index: 0;
      height: 420px;
      width: 100%;
    }

    .cuise-img {
      height: 259px;
      width: 370px;
      position: absolute;
      z-index: 1;
      right: 6%;
      top: 0px;
    }
  } 
  

  .form-box {
    width: 620px;
    height: 480px;
    background: #fff;
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 2px;
    padding: 0 40px;
    position: absolute;

    h2 {
      font-weight: 800;
      color: #000;
      font-size: 35px;
      text-align: center;
      margin-top: 0;
      margin-bottom: 8px;
    }
    p {
      font-size: 18px;
      text-align: center;
      margin: 0;
      .under-line {
        text-decoration: underline;
        margin: 0;
        cursor: pointer;
        color: #2885e2;
      }
    }

    .input-box {
      margin-top: 48px;
      display: flex;
      align-items: center;

      .area-box {
        height: 56px;
        width: 114px;
        box-shadow: 0px 2px 5px #8F9698;
        margin-right: 10px;
        border-radius: 4px;
      }
      .input {
        height: 56px;
        flex: 1;
        box-shadow: 0px 2px 5px #8F9698;
        border-radius: 4px;
        padding-left: 20px;
        font-size: 20px;
        font-weight: 600;
        &::placeholder {
          font-weight: 500;
        }
      }
    }

    .check-box {
      margin-top: 20px;
      display: flex;
      font-size: 18px;
      padding-left: 126px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    
      :deep(.el-checkbox__inner) {
        background-color: #DCDFE6;
      }
      :deep(.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner) {
        background-color: #09CA6A;
        border-color: #09CA6A;
      }
      :deep(.el-checkbox__inner) {
        transform: scale(1.4);
      }
      span {
        margin-left: 15px;
        cursor: pointer;
      }
      p {
        margin-top: 10px;
        display: block;
        font-size: 14px;
        line-height: 20px;
        color: #474747;
        text-align: left;
        .under-line {
          text-decoration: underline;
          margin: 0;
          cursor: pointer;
          color: #2885e2;
        }
      }
    }
    .sign-btn {
      margin-left: 128px;
      margin-top: 20px;
      height: 58px;
      background-color: #09CA6A;
      color: #fff;
      font-size: 22px;
      letter-spacing: 1px;
      font-weight: 600;
      border-radius: 6px;
      box-shadow: 0px 3px 6px #8F9698;
      transition: all .2s ease-in;
      cursor: pointer;
      &:hover {
        background-color: #0fda74;
        box-shadow: 0px 5px 10px #6f7577;
      }
    }
    .disable-btn {
      background-color: #999;
      &:hover {
        background-color: #999;
        box-shadow: 0px 5px 10px #6f7577;
      }
    }
    .ver-code {
      margin: 40px auto;
      display: flex;
      position: relative;
      width: 400px;
      overflow: visible;

      input {
        height: 58px;
        position: absolute;
        z-index: 10;
        width: 400px;
        border: 1px solid black;
        opacity: 0;
        background-color: transparent;
        box-sizing: border-box;
      }
      .mask-box {
        display: flex;
        justify-content: center;
        width: 400px;
        .font-box {
          height: 65px;
          min-width: 68px;
          border-radius: 4px;
          margin-right: 30px;
          box-shadow: 0px 3px 6px #8F9698;
          background-color: #fff;
          font-size: 30px;
          color: #000;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          position: relative;

          .ol-line {
            height: 40px;
            width: 2px;
            border-radius: 1px;
            background-color: #000;
            animation: breath 1.2s ease-in-out infinite  alternate forwards;
            position: absolute;
            left: 22%;
            top: 50%;
            transform: translateY(-50%);
            z-index: 20;
          }
        }
      }
    }

    @keyframes breath {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
    .top-box {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 20px;

      i {
        font-size: 26px;
        
        color: #000;
        cursor: pointer;
        transition: all ease-in .2s;
        text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);
        &:hover {
          color: $mainColor;
        }
      }
      .back {
        position: relative;
        left: -30px;
      }
      .close {
        position: relative;
        right: -40px;
      }
    }
  }
}
</style>
